import { createContext } from 'react';

const MatchGroupContext = createContext();

export default MatchGroupContext;